import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { Button, InputGroup, FormControl } from 'react-bootstrap';

interface FontSizeSelectorProps {
  minSize?: number;
  maxSize?: number;
  fontSize?: number;
  onChange?: (size: number) => void;
}

const FontSizeSelector: React.FC<FontSizeSelectorProps> = ({
  minSize = 8,
  maxSize = 500,
  onChange,
  fontSize
}) => {
  const changeSize = (amount: number) => {
    const newSize = Math.min(maxSize, Math.max(minSize, fontSize + amount));

    if (onChange) onChange(newSize);
  };

  return (
    <div
      style={{
        height: '40px'
      }}
      className="border rounded d-flex p-1 justify-content-center align-items-center gap-1"
    >
      <Button
        variant="light"
        className="p-1 px-2 h-100"
        onClick={() => changeSize(-1)}
      >
        <i
          style={{
            paddingRight: 0
          }}
          className="fa-duotone fa-minus fs-6 "
        ></i>
      </Button>
      <FormControl
        value={fontSize}
        type="number"
        onChange={(e) => {
          let newSize = parseInt(e.target.value, 10);

          if (isNaN(newSize)) return; // Prevent NaN cases

          newSize = Math.min(maxSize, Math.max(minSize, newSize)); // Clamp value

          if (onChange) onChange(newSize);
        }}
        className="text-center border-0 fs-5 p-0 m-0 no-arrows"
        style={{ maxWidth: '40px' }}
      />

      <Button
        variant="light"
        className="p-1 px-2 h-100"
        onClick={() => changeSize(1)}
      >
        <i
          style={{
            paddingRight: 0
          }}
          className="fa-duotone fa-plus fs-6 "
        ></i>
      </Button>
    </div>
  );
};

export default FontSizeSelector;
